import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL, PROVIDER_VERIFICATION} from "../config/app";

const URL = API_URL

export const signaturesService = {
  getDocumentInfo,
  getContainerInfo,
  sign,
  signContainer,
  reject,
  rejectContainer,
  remoteEmailValidation,
  updateSignatureEmail,
  startSignatureFlow,
  getSignatureFlow,
  signSignatureFlow,
  retrySignatureFlow,
  resetSignatureFlow,
  searchSigners,
  searchSignersByEmail
}

function getDocumentInfo(uuid) {
  const requestOptions = {
    method: 'GET',
  };

  return fetch(URL + "/signatures/" + uuid + "/documents", requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function getContainerInfo(uuid, signatureId) {
  const requestOptions = {
    method: 'GET',
  };

  return fetch(URL + "/containers/" + uuid + "/sign/" + signatureId, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function sign(key, cer, pfx, password, uuid) {
  let formData = new FormData();
  if (pfx) {
    formData.append("pfx", pfx);
  } else {
    formData.append("key", key);
    formData.append("cer", cer);
  }
  formData.append("password", password);
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/sign/" + uuid, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function signSignatureFlow(signatureId, signatureFlowId, svg, video) {
  let formData = new FormData();
  formData.append('signatureStroke', svg, 'signatureStroke.svg')
  if (video !== null) {
    formData.append('video', video, 'video.webm')
  }

  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/sign/" + signatureId + "?signatureFlowId=" + signatureFlowId, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function signContainer(key, cer, pfx, password, uuid, signatureId) {
  let formData = new FormData();
  if (pfx) {
    formData.append("pfx", pfx);
  } else {
    formData.append("key", key);
    formData.append("cer", cer);
  }
  formData.append("password", password);
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/containers/" + uuid + "/sign/" + signatureId, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function reject(motive, uuid) {
  let formData = new FormData();
  formData.append("reject", "true");
  formData.append("commentary", motive);
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/sign/" + uuid, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function rejectContainer(motive, uuid, signatureId) {
  let formData = new FormData();
  formData.append("reject", "true");
  formData.append("commentary", motive);
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/containers/" + uuid + "/sign/" + signatureId, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function remoteEmailValidation(email) {
  const requestOptions = {
    method: 'GET',
  };

  return fetch("https://apilayer.net/api/check?access_key=93a205cc934137172cf19b4c2fe23c7f&email=" + email + "&smtp=1&format=1", requestOptions)
    .then(
      (result => result.json().then(
        (response) => {
          if (response.score <= 0.6) {
            return Promise.reject(false)
          } else {
            return Promise.resolve();
          }
        }
      ))
    )
}

function updateSignatureEmail(email, documentUuid, signatureUuid) {
  let formData = new FormData();
  formData.append("email", email);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'PATCH',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/documents/" + documentUuid + "/signatures/" + signatureUuid, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function startSignatureFlow(signatureId, providerVerification = PROVIDER_VERIFICATION.VERIFICAMEX) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      providerVerification: providerVerification
    })
  };

  return fetch(URL + "/v1/signatures/" + signatureId + "/signature_flows", requestOptions)
    .then(
      result => {
        if (!result.ok) {
          return Promise.reject("Número máximo de intentos")
        }
        return result.json().then(
          response => {
            // providerData trae verificationUrl y, en las sesiones V3 de Verificamex, version: "v3".
            if (response)
              return Promise.resolve(response.data[0].attributes.providerData)
            else
              return Promise.reject("Número máximo de intentos")
          }
        )
      },
      error => Promise.reject(error)
    )
}

function getSignatureFlow(signatureId, signatureFlowId) {
  const requestOptions = {
    method: 'GET',
  };

  return fetch(URL + "/v1/signatures/" + signatureId + "/signature_flows/" + signatureFlowId, requestOptions)
    .then(
      (result => result.json().then(
        response => Promise.resolve(response)
      ))
    )
}

function searchSigners(query) {
  let headers = authHeader();

  const requestOptions = {
    method: 'GET',
    headers: headers,
  };

  return fetch(URL + "/signatures/search?search=" + query, requestOptions)
    .then(
      (result => result.json().then(
        response => Promise.resolve(response)
      ))
    )
}

function searchSignersByEmail(email) {
  let headers = authHeader();

  const requestOptions = {
    method: 'GET',
    headers: headers,
  };

  return fetch(URL + "/signatures/search/email?email=" + email, requestOptions)
    .then(
      (result => result.json().then(
        response => Promise.resolve(response)
      ))
    )
}

function retrySignatureFlow(signatureId, signatureFlowId) {
  const requestOptions = {
    method: 'POST',
  };

  return fetch(URL + "/v1/signatures/" + signatureId + "/signature_flows/" + signatureFlowId + "/retry", requestOptions)
    .then(
      (result => result.json().then(
        (response) => {
          return Promise.resolve(response.data[0].attributes.providerData.verificationUrl)
        }
      ))
    )
}

function resetSignatureFlow(signatureId, signatureFlowId) {
  let headers = authHeader();

  const requestOptions = {
    method: 'POST',
    headers: headers,
  };

  return fetch(URL + "/signatures/" + signatureId + "/signature_flows/" + signatureFlowId + "/reset", requestOptions)
    .then(
      (result => result.json().then(
        (response) => {
          return Promise.resolve(response)
        }
      ))
    )
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
